   export function getHash(route) {

      //var f = route.replace('#\/','');
      //console.log(route);
      var f = route.replace(/\//g,'');
      var q = f.slice(1).split('#');

      var pairs = q[0].split('&');
      var result = {};

      pairs.forEach(function(pair) {
        pair = pair.split('=');
        result[pair[0]] = decodeURIComponent(pair[1] || '');
      });

      //console.log(result)
      return result;
    }

  export function hasHash(route){
      var f = route.replace(/\//g,'');
      var q = f.slice(1).split('#');

      //console.log(q);
      if(q[0]){
        return true
      } else {

        return false
      }

  }

    export function isLoginHash(route){

        if(route.search("id_token") > 0){
            return true;

        } else {
            return false;

        }


  }


  export function processLogin(route){



  }


  /* Using Cognito Session Object */

  export function constructUserCredentials(cognitoUser, session) {
    let auth_data = session.idToken.payload;
    auth_data.username = cognitoUser.getUsername();

    let hashtokens = {
      access_token: session.getAccessToken().getJwtToken(),
      expires_in: session.idToken.payload.exp - session.idToken.payload.auth_time,
      id_token: session.getIdToken().getJwtToken(),
      refresh_token: session.getRefreshToken().getToken(),
      token_type: 'Bearer'
    };

    return {
      auth: auth_data,
      hashtokens: hashtokens,
    };

  }
